<template>
  <div class="offcanvas offcanvas-end" tabindex="-1" id="UserShowOffcanvas" data-bs-backdrop="static" aria-labelledby="userShowOffcanvasLabel">
    <div class="offcanvas-header">
      <button class="btn-back" id="btnCloseUserShowOffcanvas" type="button" name="button" data-test="btnCloseOffcanvas" data-bs-dismiss="offcanvas" :aria-label="$t('close')" @click="doClose">
        <IconArrowBack/>
        {{ $t('goBack') }}
      </button>

      <div class="">
        <p>
          <span>{{ $t('user.userOf') }}</span>&nbsp;<b>{{ session.currentClinic.name }}</b>
        </p>

        <div class="">
          <h5 class="offcanvas-title" id="userShowOffcanvasLabel">{{ fullName }}</h5>
          <button class="btn btn-outline-secondary" type="button" name="button" data-test="btnLogout" @click="logout">
            <IconLogout/>
            {{ $t('user.logout') }}
          </button>
        </div>

        <p>
          <span>{{ $t('user.memberSince') }}</span>&nbsp;<b>{{ memberSinceFormatted }}</b>
        </p>
      </div>
    </div>

    <vee-form v-slot="{ handleSubmit }" as="div" class="form-wrap" v-if="userData.id">
    <form @submit.prevent.stop="handleSubmit(doUpdate)">
    <div class="offcanvas-body scrollbar">
      <section>
        <div class="form-floating">
          <vee-field name="firstName" v-model="userData.collaborator.firstName" rules="required" v-slot="{ field, errorMessage }">
            <input v-bind="field" type="text" class="form-control" id="userFirstName" :placeholder="$t('user.firstName')" data-test="inputUserFirstName"/>
            <span class="vee-error">{{ errorMessage }}</span>
          </vee-field>
          <label for="userFirstName">{{ $t('user.firstName') }}*</label>
        </div>
        <div class="form-floating">
          <vee-field name="lastName" v-model="userData.collaborator.lastName" rules="required" v-slot="{ field, errorMessage }">
            <input v-bind="field" type="text" class="form-control" id="userLastName" :placeholder="$t('user.lastName')" data-test="inputUserLastName"/>
            <span class="vee-error">{{ errorMessage }}</span>
          </vee-field>
          <label for="userLastName">{{ $t('user.lastName') }}*</label>
        </div>
        <div class="form-floating">
          <vee-field name="birthday" v-model="userData.collaborator.birthdayAux" :rules="`date:${$t('dateFormat')}`" v-slot="{ field, errorMessage }">
            <input v-bind="field" type="text" class="form-control" id="userBirthday" v-maska :data-maska="$t('inputMask.date')" :placeholder="$t('user.birthday')" data-test="inputUserBirthday"/>
            <span class="vee-error">{{ errorMessage }}</span>
          </vee-field>
          <label for="userBirthday">{{ $t('createAccount.dateOfBirth') }}</label>
        </div>
        <div class="form-floating">
          <input type="text" class="form-control" id="userEmail" v-model="userData.email" disabled :placeholder="$t('user.email')" data-test="inputUserEmail"/>
          <label for="userEmail">{{ $t('user.email') }}</label>
        </div>
        <div class="form-floating">
          <input type="text" class="form-control" id="userTelephone1" v-model="userData.collaborator.telephone1" :placeholder="$t('user.telephone1')" data-test="inputUserTelephone1"/>
          <label for="userTelephone1">{{ $t('user.telephone1') }}</label>
        </div>
        <div class="form-floating">
          <input type="text" class="form-control" id="userTelephone2" v-model="userData.collaborator.telephone2" :placeholder="$t('user.telephone2')" data-test="inputUserTelephone2"/>
          <label for="userTelephone2">{{ $t('user.telephone2') }}</label>
        </div>
        <div class="form-floating" v-if="userData.permissions !== 'technician'">
          <input type="text" class="form-control" id="userNpi" v-model="userData.collaborator.npi" :placeholder="$t('user.npi')" data-test="inputUserNpi"/>
          <label for="userNpi">{{ $t('user.npi') }}</label>
        </div>

        <div class="signature-box" v-if="userData.permissions !== 'technician' && userData.collaborator.npi">
          <label>{{ $t('user.signature') }}</label>

          <input id="signatureFileUpload" type="file" ref="signatureFileInput" @change="onSignatureFileChange" accept="image/*" hidden/>

          <div class="signature-preview" v-if="!showSignatureCropper">
            <img v-if="signature" :src="signature" alt=""/>
            <button class="btn btn-outline-secondary" type="button" name="button" data-test="btnBrowseSignature" @click="$refs.signatureFileInput.click()">
              {{ $t('user.browse') }}
            </button>
          </div>

          <div class="signature-cropper-box" v-else>
            <cropper ref="signatureCrop" class="cropper" :src="signatureImgSrc" background-class="cropper-background" :stencil-props="{aspectRatio: 2/1}"/>

            <div class="signature-cropper-actions">
              <button class="btn btn-outline-secondary" type="button" name="button" data-test="btnCancelSignature" @click="cancelSignatureCropper">
                {{ $t('cancel') }}
              </button>
              <button class="btn btn-success" type="button" name="button" data-test="btnSaveSignature" @click="saveSignature">
                {{ $t('save') }}
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>

    <div class="offcanvas-footer">
      <button class="btn btn-success" type="submit" name="button" data-test="btnUpdateUser" v-if="hasFormChanged">
        {{ $t('user.modify') }}
      </button>
      <button class="btn btn-outline-secondary" type="button" name="button" data-test="btnOpenModalPassword" @click="openChangePassword">
        {{ $t('user.changePassword') }}
      </button>
      <button class="btn btn-outline-secondary" type="button" name="button" data-test="btnOpenModalPin" @click="openChangePin">
        {{ $t('user.changePIN') }}
      </button>
    </div>
    </form>
    </vee-form>

    <teleport to="body">
      <UserChangePasswordOffcanvas v-if="hasOpened" :offcanvas_id="'userChangePasswordFromHeader'" ref="userChangePasswordOffcanvas"/>
      <UserChangePinOffcanvas v-if="hasOpened" :offcanvas_id="'userChangePinFromHeader'" ref="userChangePinOffcanvas"/>
    </teleport>
  </div>
</template>

<style lang="scss" scoped>
#UserShowOffcanvas {
  width:                                100% !important;
  max-width:                            580px;
  padding:                              0;

  .btn {
    height:                             36px;
    min-height:                         unset;
    padding:                            10px;
    font-size:                          12px;
    font-weight:                        500;
    letter-spacing:                     2.58px;
  }

  .offcanvas-header {
    display:                            flex;
    flex-direction:                     column;
    justify-content:                    flex-start;
    align-items:                        flex-start;
    flex:                               0 0 auto;
    gap:                                15px;
    padding:                            30px 30px 15px 30px;

    .offcanvas-title {
      text-transform:                   capitalize;
    }

    p,
    .offcanvas-title {
      color:                            var(--Brand-Primary);
      margin:                           0;
    }

    p:first-child,
    p span,
    .offcanvas-title {
      font-weight:                      300;
    }

    p {
      font-size:                        var(--font-size-14);
      line-height:                      140%; /* 19.6px */

      b {
        font-weight:                    700 !important;
      }
    }

    > div {
      width:                            100%;

      > div {
        display:                        flex;
        flex-direction:                 row;
        align-items:                    center;
        justify-content:                space-between;
        gap:                            10px;
        margin-bottom:                  15px;

        .btn {
          display:                      flex;
          gap:                          10px;

          svg {
            width:                      16px;
            height:                     16px;
          }
        }
      }
    }
  }

  .form-wrap,
  form {
    display:                            flex;
    flex-direction:                     column;
    flex:                               1;
    min-height:                         0;
  }

  .offcanvas-body {
    display:                            flex;
    flex-direction:                     column;
    flex:                               1;
    justify-content:                    flex-start;
    min-height:                         0;
    gap:                                20px;
    margin-right:                       30px;
    padding:                            15px 10px 20px 30px;
    overflow-x:                         hidden;

    section {
      display:                          flex;
      flex-direction:                   column;
      gap:                              15px;
    }

    .signature-box {
      display:                          flex;
      flex-direction:                   column;
      gap:                              8px;

      label {
        color:                          var(--Shades-50);
        font-size:                      var(--font-size-12);
        letter-spacing:                 0.6px;
        text-transform:                 uppercase;
      }

      .signature-preview {
        @include                        border_radius(10px);
        position:                       relative;
        display:                        flex;
        align-items:                    center;
        justify-content:                center;
        min-height:                     120px;
        padding:                        15px;
        border:                         1px dashed var(--Shades-30-Border);

        img {
          max-width:                    100%;
          max-height:                   90px;
        }

        .btn {
          position:                     absolute;
          right:                        15px;
          bottom:                       15px;
        }
      }

      .signature-cropper-box {
        display:                        flex;
        flex-direction:                 column;
        gap:                            15px;

        .cropper {
          height:                       200px;
          background:                   var(--Shades-10);
        }

        .signature-cropper-actions {
          display:                      flex;
          flex-direction:                row;
          gap:                          15px;

          .btn {
            flex:                       1;
          }
        }
      }
    }
  }

  .offcanvas-footer {
    @include                             border_radius(10px 10px 0 0);
    @include                             box_shadow(0 0 10px 0 rgba(0, 0, 0, 0.25));
    position:                            relative;
    display:                             flex;
    flex-direction:                      row;
    gap:                                 15px;
    padding:                             20px;
    z-index:                             4;
    isolation:                           isolate;

    .btn {
      flex:                              1;
    }
  }
}

.vee-error {
  width:                                 100% !important;
}
</style>

<script>
import { useUserStore } from '@/store/user'
import UserChangePasswordOffcanvas from './UserChangePasswordOffcanvas.vue'
import UserChangePinOffcanvas from './UserChangePinOffcanvas.vue'

export default {
  name: 'UserShowOffcanvas',
  components: {
    UserChangePasswordOffcanvas,
    UserChangePinOffcanvas,
  },
  data: () => ({
    loading: false,
    hasOpened: false,
    session: {
      collaborator: {},
      currentClinic: {}
    },
    userData: {
      collaborator: {
        firstName: '',
        lastName: '',
        birthday: '',
        birthdayAux: '',
        telephone1: '',
        telephone2: '',
        npi: '',
      },
      createdAt: '',
      email: '',
      id: '',
      permissions: '',
    },
    hasFormChanged: false,
    initialForm: {},
    changedFormItems: [],
    offcanvasUserShow: null,
    resolvePromise: null,
    rejectPromise: null,
    signature: null,
    showSignatureCropper: false,
    signatureImgSrc: null,
  }),
  watch: {
    userData: {
      handler(newValue) {
        this.checkFormChange(newValue, 'userData')
      },
      deep: true
    },
  },
  computed: {
    fullName() {
      return `${this.userData.collaborator.firstName} ${this.userData.collaborator.lastName}`
    },
    memberSinceFormatted() {
      return this.$utils.formatDate(this, this.userData.createdAt)
    },
  },
  methods: {
    checkFormChange(value, obj) {
      let hasObj = this.changedFormItems.includes(obj)
      if (JSON.stringify(value) === JSON.stringify(this.initialForm[obj])) {
        if (hasObj) {
          let index = this.changedFormItems.indexOf(obj)
          this.changedFormItems.splice(index, 1)
        }

        if (this.changedFormItems.length > 0)
          return

        this.hasFormChanged = false
      } else {
        if (!hasObj)
          this.changedFormItems.push(obj)

        this.hasFormChanged = true
      }
    },

    show() {
      const userStore = useUserStore()
      this.session = userStore.sessionInfo

      this.hasFormChanged = false
      this.changedFormItems = []
      this.hasOpened = true

      this.fetchData()

      this.offcanvasUserShow = bootstrap.Offcanvas.getOrCreateInstance(this.$el);
      this.offcanvasUserShow.show();

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },

    async fetchData() {
      let params = {
        id: this.session.user.id,
      }

      this.loading = true
      NProgress.start()
      try {
        let response = await this.$userService.getUser(params);

        this.userData = response.result

        if (this.userData.collaborator?.signature) {
          const signatureResponse = await this.$userService.getSignature()
          this.signature = signatureResponse.result
        } else {
          this.signature = null
        }

        const DATE_FORMAT = this.$i18n.t('dateFormat');
        if (this.userData.collaborator) {
          this.userData.collaborator.birthdayAux = this.userData.collaborator.birthday
            ? moment.utc(this.userData.collaborator.birthday).format(DATE_FORMAT)
            : "";
        }

        const formWrap = {
          userData: this.userData
        }

        this.initialForm = _.cloneDeep(formWrap)
      } catch (err) {
        this.$message.popup(this, 'request_error', 'operationFail', 'error')
      }
      NProgress.done(true)
      this.loading = false
    },

    async doUpdate() {
      const birthdayAux = this.userData.collaborator.birthdayAux
      this.userData.collaborator.birthday = birthdayAux
        ? moment.utc(birthdayAux, this.$i18n.t('dateFormat'), true).format('YYYY-MM-DD')
        : ''

      let params = {
        user: this.userData
      }

      params.user.npi = this.userData.collaborator.npi

      this.loading = true
      NProgress.start()
      try {
        await this.$userService.updateUser(params)
        this.$message.popup(this, 'general.updatedSuccess', 'operationSuccess', 'success')
        this.fetchData()
      } catch (err) {
        this.$message.popup(this, 'general.updatedError', 'operationFail', 'error')
      }
      NProgress.done(true)
      this.loading = false
    },

    async openChangePassword() {
      await this.$refs.userChangePasswordOffcanvas.show({
        title: this.$i18n.t('user.changePassword'),
        okButton: this.$i18n.t('user.modify'),
        okButtonClass: 'btn-success',
      })
    },

    async openChangePin() {
      await this.$refs.userChangePinOffcanvas.show({
        title: this.$i18n.t('user.changeDevicePIN'),
        okButton: this.$i18n.t('user.modify'),
        okButtonClass: 'btn-success',
      })
    },

    async logout() {
      await this.$authService.logout(this)
      window.open('/', '_self');
    },

    doClose() {
      this.offcanvasUserShow = null;
      this.resolvePromise(false)
    },

    onSignatureFileChange(event) {
      const file = event.target.files[0]
      if (!file || !file.type.startsWith('image/'))
        return

      if (this.signatureImgSrc && this.signatureImgSrc.startsWith('blob:'))
        URL.revokeObjectURL(this.signatureImgSrc)

      this.signatureImgSrc = URL.createObjectURL(file)
      this.showSignatureCropper = true
    },

    cancelSignatureCropper() {
      if (this.signatureImgSrc && this.signatureImgSrc.startsWith('blob:'))
        URL.revokeObjectURL(this.signatureImgSrc)

      this.signatureImgSrc = null
      this.showSignatureCropper = false
      this.$refs.signatureFileInput.value = ''
    },

    saveSignature() {
      if (!this.$refs.signatureCrop)
        return

      const { canvas } = this.$refs.signatureCrop.getResult()
      if (!canvas)
        return

      canvas.toBlob(blob => {
        this.uploadSignature(blob)
      }, 'image/png')
    },

    async uploadSignature(blob) {
      let params = {
        id: this.userData.id,
        data: blob,
        removeSignature: false,
      }

      this.loading = true
      NProgress.start()
      try {
        let response = await this.$userService.uploadSignature(params)
        this.signature = response.userSignature
        this.$message.popup(this, 'general.updatedSuccess', 'operationSuccess', 'success')
        this.cancelSignatureCropper()
      } catch (err) {
        this.$message.popup(this, 'general.updatedError', 'operationFail', 'error')
      }
      NProgress.done(true)
      this.loading = false
    },
  }
}
</script>
